import React from 'react';
import './App.css';
import ContactManager from "./components/ContactManager/ContactManager";

const contacts = ["Joshua", "Peter", "Paul", "Esther"]

function App() {
  return (
    <div className="App">
      <header>
        <h1>Contact Manager</h1>
      </header>
      <div className="contact-manager">
        <ContactManager data={contacts}/>        
      </div>
    </div>
  );
}

export default App;
